import React from 'react';
import localforage from 'localforage';
import { Box } from '@styleseat/ui';
import { HeaderText, Button } from '../../../ui';
import PortalOverlay, {
  PortalOverlayHeader,
  PortalOverlayModal,
  PortalOverlayHeaderCloseBtn,
} from '../../../ui/PortalOverlay';

import { ABTestMenuContainer } from './ABTestMenuContainer';

export const ABTestMenuModal: React.FC<{
  onClose: () => void,
}> = ({
  onClose,
}) => {
  const handleStorageClear = () => {
    localforage.clear();
    localStorage?.clear?.();
  };

  return (
    <PortalOverlay name="abtest-menu" animationStyle="slideUp">
      <PortalOverlayModal position="fullScreen">
        <PortalOverlayHeader
          renderTitle={() => <Box justifyContent="center"><HeaderText level={2}>Developer Menu</HeaderText></Box>}
          renderRightAction={() => <PortalOverlayHeaderCloseBtn onCloseRequest={onClose} />}
        />
        <Box>
          <Button appearance="outline" onClick={handleStorageClear}>
            Clear Local Storage
          </Button>
        </Box>
        <ABTestMenuContainer />
      </PortalOverlayModal>
    </PortalOverlay>
  );
};
